export const roundedWithFrac = (value: number) => {
  const convertedValue = Number(value);
  return (
    (convertedValue &&
      `${convertedValue.toLocaleString(undefined, {
        maximumFractionDigits: 2
      })}`) ||
    "0"
  )
}

export const roundedWithFracDigits = (value: number, maximumFractionDigits: number = 2) => {
  const convertedValue = Number(value);
  return (
    (convertedValue &&
      `${convertedValue.toLocaleString(undefined, {
        maximumFractionDigits
      })}`) ||
    "0"
  )
}
